import { Component, OnInit, AfterViewInit, Input, PLATFORM_ID, Inject, HostListener, trigger, state, style, transition, animate } from '@angular/core';
import { isPlatformBrowser, isPlatformServer, Location } from '@angular/common';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Observable } from 'rxjs';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/takeUntil';
import { Subject } from 'rxjs/Subject';
import { MetaService } from 'angular-engine/engine/service/meta/meta.service';
import { ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { APP_SETTINGS, DeviceInfo, DEVICE_INFO } from 'angular-engine/modules/ng-express-engine/tokens';
import { MobileNavigationService } from 'angular-engine/engine/service/ui/mobile-navigation/mobile-navigation.service';
import { EventInteraction } from 'angular-engine/engine/service/dynamic/event.interaction.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
//import { SearchService } from 'angular-engine/engine/service/search/search.service';

@Component({
  selector: 'static-container',
  template: ``,
  styles: [`
    :host ::ng-deep :last-child{
      margin-bottom:0;
    }
  `],
  providers: [
    MetaService
  ]
})
export class StaticContainer {
  @Input() content: any;
  @Input() isServer: boolean;
  @Input() onRouteChange: boolean = false;
  protected metaSubscription: Subscription;
  private componentFunctionString: string;
  private routeSnapshotParams;
  protected ngUnsubscribe: Subject<void> = new Subject<void>();
  protected dataService: BehaviorSubject<Object>;
  public isPhone:boolean = false;
  public isMobile:boolean;
  public allowRouteDataLoad:boolean = true
  constructor(
    protected coreEffects: CoreEffects,
    @Inject(PLATFORM_ID) protected platformId: string,
    protected ref: ChangeDetectorRef,
    protected router: Router,
    protected route: ActivatedRoute,
    protected metaService: MetaService,
    protected location: Location,
    @Inject(APP_SETTINGS) protected settings: any,
    protected mobileNavigationService: MobileNavigationService,
    @Inject(DEVICE_INFO) device: DeviceInfo,
    protected eventInteractions:EventInteraction,
    //protected uiStateEngine:UIStateEngine,
    //protected searchService:SearchService
  ) {
    this.isServer = isPlatformServer(this.platformId);
    this.dataService = new BehaviorSubject(null);
    if (device) {
      this.isPhone = device.isPhone;
      this.isMobile = device.isMobile;
    }
  }

  private jsonEqual(a, b) {
    return JSON.stringify(a) === JSON.stringify(b);
  }


  ngOnInit() {
      if (this.allowRouteDataLoad) {
        this.content = this.dataService.asObservable();
        this.coreEffects.getRouteDataAsObservableEmit(this.dataService, this.route.snapshot.params);


        this.content.takeUntil(this.ngUnsubscribe).subscribe(data => {
          if (!this.isServer) {
            this.onDataReady(data);
            
            if (this.router.navigated) {
              window.scrollTo(0, 0);
            }

            var navCheck: any = document.getElementById('main-nav-check');
            if (navCheck) {
              navCheck.checked = false;
            }
          }

          if(this.isPhone && this.settings["MOBILE_SWIPE_NAVIGATION"])
          {
            this.setData(data);
          }
          
        });

        if(!this.settings["CAMPAIGN_APPLICATION"])
        {
          this.metaSubscription = this.content.subscribe((data: any) => {
            if (data != null) {
              if (typeof data.meta !== "undefined") {
                if(this.isServer)
                {
                  this.metaService.processMeta(data.meta);
                }
                else{
                  this.metaService.setDynamicSearchTitle(data.meta.title, data.meta.unique_id);
                } 
              }
            }
          });
        }
        
    }
  }

  setData(data:any){
    if(!this.settings["MOBILE_SWIPE_NAVIGATION"])
      return;

    if(data && data.rows)
    {
      data.rows = data.rows.filter(row => row.meta.obj_type != "Promotion");
    }
    this.mobileNavigationService.setData(data);
  }

  ngOnDestroy() {
    this.location = null;
    this.content = null;

    if (this.ngUnsubscribe) {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
      this.ngUnsubscribe.unsubscribe();
    }
    if (this.metaSubscription) {
      this.metaSubscription.unsubscribe();
    }
    if (this.dataService){
      this.dataService.complete();
      this.dataService = null;
    }
  }

  protected onDataReady(data) {
    //override if necessary
  }
}


// WEBPACK FOOTER //
// ./src/angular-shared-features/feature/shared-component/static-container.component.ts